import styled from '@emotion/styled'

const Container = styled.section`
  & {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    flex-flow: column nowrap;
  }

  & > * {
    width: 100%;
  }
`

export default Container
